import Clickable from 'components/Common/Clickable'
import Pane from 'components/Common/Pane'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import RadioButton from 'LuxKit/Radio/RadioButton'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'

const FullHeightPane = styled(Pane)`
  width: ${rem(250)};
  height: 100%;

  ${mediaQueryUp.desktop} {
    width: unset;
    flex: 1;
  }
`

interface Props {
  fareId: string
  isSelected: boolean
  name: string
  subtitle: React.ReactNode
  imageId: string
  onSelect: (fareId: string) => void
}

function FareClassCard({ fareId, isSelected, name, subtitle, imageId, onSelect, children }: React.PropsWithChildren<Props>) {
  const onClick = useCallback(() => {
    onSelect(fareId)
  }, [fareId, onSelect])

  return <Clickable onClick={onClick}>
    <FullHeightPane border={isSelected ? 'neutral-one' : 'neutral-five'} padding="24 16">
      <VerticalSpacer gap={16}>
        <Group direction="horizontal" gap={8}>
          <RadioButton checked={isSelected} />
          <VerticalSpacer gap={4}>
            <Heading variant="heading6">{name}</Heading>
            {subtitle}
          </VerticalSpacer>
        </Group>
        <ResponsiveImage
          id={imageId}
          aspectRatio="218:143"
          desktopAspectRatio="310:143"
        />
        <div>
          {children}
        </div>
      </VerticalSpacer>
    </FullHeightPane>
  </Clickable>
}

export default FareClassCard
